<template>
  <TemplateModal
    ref="modal"
    center
    width="800"
    :background="stage === 3 ? '#ffffff' : '#E5E5E5'"
    :sendFunction="stage === 0 ? onCreateOrUpdateDay : onCreateReport"
    empty
  >
    <template v-slot:activator>
      <BaseButton
        v-if="createDay || updateDay"
        @click="!buttonDisabled ? onOpenCreate() : null"
        :icon_only="!buttonText"
        :default_icon="createDay ? 'button-add' : 'button-edit'"
        :reverse="reverse"
        height="40"
        :class="buttonClass"
        v-show="buttonShow"
        :disabled="buttonDisabled"
        :text="buttonText"
      />
      <BaseButton
        v-else
        @click="!buttonDisabled ? $refs.modal.openModal() : null"
        :text="localStorage.mobile.pages.mob_working_time.buttons['dobavit-otchet']"
        default_icon="button-add"
        height="40"
        :reverse="reverse"
        :class="buttonClass"
        :disabled="buttonDisabled"
        v-show="buttonShow"
      />
    </template>
    <div class="wrap">
      <div class="day" v-if="stage === 0">
        <BaseInput
          :label="localStorage.translations.pages.common['text']['start_date']"
          v-model="start_date"
          type="date-picker"
          :date-max="new Date().toISOString().slice(0, 10)"
          dateMin
          bold
          :rules="['required']"
        />
        <BaseInput
          :label="localStorage.translations.pages.common['text']['start_time']"
          v-model="start_time"
          inputType="time"
          bold
          :rules="['required']"
          :disabled="!start_date"
        />
        <BaseInput
          :label="localStorage.translations.pages.common['text']['end_date']"
          v-model="end_date"
          type="date-picker"
          :date-min="start_date"
          :date-max="new Date().toISOString().slice(0, 10)"
          bold
          :disabled="!start_time"
          :show-current="end_date ? end_date : start_date"
        />
        <BaseInput
          :label="localStorage.translations.pages.common['text']['end_time']"
          v-model="end_time"
          inputType="time"
          bold
          :disabled="!end_date"
        />
      </div>
      <div class="projects" v-if="stage === 1">
        <p class="f24 fw500">
          {{ localStorage.mobile.pages['mob_working_time-report'].titles.select_project }}
        </p>
        <div class="projects_grid">
          <div
            class="projects_item"
            v-for="(project, key) in projectsList"
            :key="key"
            @click="
              onNextStage({
                project_id: project.project_id,
                is_extra: project.is_extra,
              })
            "
          >
            <IconProjectType :extra="project.is_extra === 1 ? true : false" />
            {{ project.project }}
          </div>
        </div>
      </div>
      <div class="works" v-else-if="stage === 2">
        <div class="works_item works_item--head f18 fw500">
          {{
            projectsList.find(
              (i) => i.project_id === projectSelect.id && i.is_extra === projectSelect.is_extra,
            ).project
          }}
        </div>
        <div class="works_item works_item--subhead f16 fw500">
          {{ localStorage.mobile.pages['mob_working_time-report'].sections['vidy-rabot'] }}
        </div>
        <div
          class="works_item works_item--work f18"
          v-for="(work, key) in employeeReports.periods.filter((i) =>
            dates.end
              ? i.project_id === projectSelect.id &&
                i.is_extra === projectSelect.is_extra &&
                dates.start.split(' ')[0] >= i.start_date &&
                dates.start.split(' ')[0] <= i.end_date &&
                dates.end.split(' ')[0] >= i.start_date &&
                dates.end.split(' ')[0] <= i.end_date
              : i.project_id === projectSelect.id &&
                i.is_extra === projectSelect.is_extra &&
                dates.start.split(' ')[0] >= i.start_date &&
                dates.start.split(' ')[0] <= i.end_date,
          )"
          :key="key"
          @click="onNextStage({ employee_period_id: work.employee_period_id })"
        >
          {{ work.work_type }}
        </div>
        <div class="works_item works_item--subhead f16 fw500">
          {{ localStorage.mobile.pages['mob_working_time-report'].titles.additional_work_type }}
        </div>
        <div
          class="works_item works_item--work f18"
          v-for="(workExtra, key) in workExtraTypeAll"
          :key="'extra_' + key"
          @click="onNextStage({ work_extra_type_id: workExtra.id })"
        >
          {{ workExtra.name }}
        </div>
      </div>
      <div class="last" v-else-if="stage === 3">
        <div class="last_col">
          <p class="f24 fw500">
            {{ localStorage.mobile.pages['mob_working_time-report'].sections['dannye-o-proekte'] }}
          </p>
          <BaseInput
            :label="localStorage.mobile.pages['mob_working_time-report'].labels['nazvanie-proekta']"
            view
            :view-value="
              projectsList.find(
                (i) => i.project_id === projectSelect.id && i.is_extra === projectSelect.is_extra,
              ).project
            "
            bold
          />
          <BaseInput
            :label="localStorage.mobile.pages['mob_working_time-report'].labels['vid-rabot']"
            view
            :view-value="
              workSelectData.data[workSelectData.type === 'period' ? 'work_type' : 'name']
            "
            bold
          />
          <BaseInput
            v-if="workSelectData.type === 'period'"
            :label="localStorage.mobile.pages['mob_working_time-report'].labels['period']"
            view
            :view-value="
              $formatDate(workSelectData.data.start_date) +
              ' - ' +
              $formatDate(workSelectData.data.end_date)
            "
            bold
          />
          <BaseInput
            v-if="workSelectData.type === 'period'"
            :label="localStorage.mobile.pages['mob_working_time-report'].labels['fakt']"
            view
            :view-value="
              workSelectData.data.is_hourly === 0
                ? $roundNumberToTenths(workSelectData.data.done_employee) + ' ' + workSelectData.data.measure
                : $formatTime(workSelectData.data.done_employee)
            "
            bold
          />
        </div>
        <div class="last_col">
          <p class="f24 fw500">
            {{
              workSelect.employee_period_id &&
              employeeReports.periods.find(
                (i) => i.employee_period_id === workSelect.employee_period_id,
              ).is_hourly === 0
                ? localStorage.mobile.pages['mob_working_time-report'].sections['sdelochnaya']
                : localStorage.mobile.pages['mob_working_time-report'].sections['chasovaya']
            }}
          </p>
          <BaseInput
            v-model="time"
            :label="localStorage.mobile.pages['mob_working_time-report'].labels['chasy']"
            inputType="time"
            v-if="
              workSelect.work_extra_type_id ||
              employeeReports.periods.find(
                (i) => i.employee_period_id === workSelect.employee_period_id,
              ).is_hourly === 1
            "
            :rules="['requiredTime']"
          />
          <BaseInput
            v-if="
              workSelect.employee_period_id &&
              employeeReports.periods.find(
                (i) => i.employee_period_id === workSelect.employee_period_id,
              ).is_hourly === 0
            "
            v-model="pieceworkTime"
            :label="localStorage.mobile.pages['mob_working_time-report'].labels['chasy']"
            inputType="time"
          />
          <BaseInput
            v-if="workSelect.employee_period_id"
            v-model="size"
            inputType="number"
            :label="localStorage.mobile.pages['mob_working_time-report'].labels['obem']"
            :measure="
              employeeReports.periods.find(
                (i) => i.employee_period_id === workSelect.employee_period_id,
              ).measure
            "
            :rules="
              employeeReports.periods.find(
                (i) => i.employee_period_id === workSelect.employee_period_id,
              ).is_hourly === 0
                ? ['required']
                : []
            "
          />
          <BaseInput
            v-if="workSelect.employee_period_id || workSelect.work_extra_type_id"
            v-model="selected_block"
            :label="localStorage.translations.pages.common.text['block'] || 'Block'"
            type="select"
            :items="blockOptions"
            :rules="[requiredBlockSelection]"
          />

          <BaseInput
            :label="localStorage.mobile.pages['mob_working_time-report'].labels['primechanie']"
            v-model="report"
            type="textarea"
          />
        </div>
      </div>
      <div class="wrap_buttons" :class="{ 'wrap_buttons--center': stage === 0 }">
        <BaseButton
          v-if="stage > 1"
          @click="onPrevStage"
          default_icon="button-back"
          :text="localStorage.translations.pages.common['buttons']['nazad']"
        />
        <BaseButton
          v-if="stage === 0 || stage === 3"
          type="submit"
          :text="localStorage.translations.pages.common['buttons']['sohranit']"
          default_icon="button-save"
        />
      </div>
    </div>
  </TemplateModal>
</template>

<script>
import TemplateModal from 'components/templates/TemplateModal'
import IconProjectType from 'components/icons/project/IconProjectType'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'StatisticEmployeeReportModal',
  props: {
    props_dates: Object,
    edit: Boolean,
    employee_work_day_id: [String, Number],
    functionUpdate: Function,
    createDay: [Boolean, String],
    updateDay: Object,
    reverse: Boolean,
    buttonClass: [String, Object],
    buttonShow: { type: [Boolean, String, Function], default: true },
    buttonText: String,
    buttonDisabled: Boolean,
  },
  components: {
    TemplateModal,
    IconProjectType,
  },
  data: () => ({
    stage: 1,
    start_date: null,
    start_time: null,
    end_date: null,
    end_time: null,
    projectSelect: null,
    workSelect: null,
    dialog: false,
    size: null,
    hours: null,
    piecework_time_hour: null,
    selected_block: '__select_block__',
    report: null,
    time: '00:00',
    pieceworkTime: null,
    work_day_id: null,
    dates: null,
  }),
  watch: {
    modalShow() {
      if (!this.modalShow) {
        this.stage = 1
        this.projectSelect = null
        this.workSelect = null
        this.size = null
        this.hours = null
        this.piecework_time_hour = null
        this.selected_block = '__select_block__'
        this.report = null
        this.start_date = null
        this.start_time = null
        this.end_date = null
        this.end_time = null
        this.work_day_id = null
        this.dates = null
        this.time = '00:00'
        this.pieceworkTime = null
      } else {
        this.onWorkExtraTypeAll()
        this.dates = this.props_dates
      }
    },
    time() {
      if (this.time && this.time.length) {
        const [hours, minutes] = this.time.split(':')
        this.hours = parseInt(hours) * 60 + parseInt(minutes)
      } else {
        this.hours = null
      }
    },
    pieceworkTime() {
      if (this.pieceworkTime && this.pieceworkTime.length) {
        const [hours, minutes] = this.pieceworkTime.split(':')
        this.piecework_time_hour = parseInt(hours) * 60 + parseInt(minutes)
      } else {
        this.piecework_time_hour = null
      }
    },
    start_date() {
      if (this.end_date < this.start_date) {
        const start = this.start_date
        const end = this.end_date
        this.end_date = start
        this.start_date = end
      }
    },
    end_date() {
      if (this.end_date < this.start_date) {
        const start = this.start_date
        const end = this.end_date
        this.end_date = start
        this.start_date = end
      }
      if (this.end_date === this.start_date) {
        if (this.end_time < this.start_time) {
          const start = this.start_time
          const end = this.end_time
          this.end_time = start
          this.start_time = end
        }
      }
    },
    start_time() {
      if (this.end_date === this.start_date) {
        if (this.end_time < this.start_time) {
          const start = this.start_time
          const end = this.end_time
          this.end_time = start
          this.start_time = end
        }
      }
    },
    end_time() {
      if (this.end_date === this.start_date) {
        if (this.end_time < this.start_time) {
          const start = this.start_time
          const end = this.end_time
          this.end_time = start
          this.start_time = end
        }
      }
    },
  },

  computed: {
    ...mapGetters(['apiDomain', 'inputRules']),
    ...mapGetters('employee', ['employeeReports']),
    ...mapGetters('workExtraType', ['workExtraTypeAll']),
    projectsList() {
      return this.modalShow && this.onProjectsList()
    },
    modalShow() {
      return this.$refs.modal && this.$refs.modal.dialog
    },
    workSelectData() {
      let work = {
        type: null,
        data: null,
      }
      if (this.workSelect.employee_period_id) {
        work.type = 'period'
        work.data = this.employeeReports.periods.find(
          (i) => i.employee_period_id === this.workSelect.employee_period_id,
        )
      } else if (this.workSelect.work_extra_type_id) {
        work.type = 'extra'
        work.data = this.workExtraTypeAll.find((i) => i.id === this.workSelect.work_extra_type_id)
      }
      return work
    },
    blockOptions() {
      const blocks =
        this.workSelectData.type === 'period'
          ? Array.isArray(this.workSelectData?.data?.blocks)
            ? this.workSelectData.data.blocks
            : []
          : this.selectedProjectBlocks
      return [
        {
          id: '__select_block__',
          name: this.localStorage.translations.pages.common.text['select_block'] || 'Select Block',
          disabled: true,
        },
        ...blocks.map((block) => ({ id: block, name: block })),
        {
          id: '',
          name: this.localStorage.translations.pages.common.text['not_specified'] || 'Not Specified',
        },
      ]
    },
    selectedProjectBlocks() {
      if (!this.projectSelect || !Array.isArray(this.employeeReports?.periods) || !this.dates?.start) {
        return []
      }
      const dateStart = this.dates.start.split(' ')[0]
      const dateEnd = this.dates.end ? this.dates.end.split(' ')[0] : null
      const blocks = []

      for (let period of this.employeeReports.periods) {
        const isRightProject =
          period.project_id === this.projectSelect.id &&
          period.is_extra === this.projectSelect.is_extra
        const isInRange = dateEnd
          ? dateStart >= period.start_date &&
            dateStart <= period.end_date &&
            dateEnd >= period.start_date &&
            dateEnd <= period.end_date
          : dateStart >= period.start_date && dateStart <= period.end_date
        if (!isRightProject || !isInRange || !Array.isArray(period.blocks)) continue
        for (let block of period.blocks) {
          if (!blocks.includes(block)) blocks.push(block)
        }
      }

      return blocks
    },
  },
  mounted() {
    this.dates = this.props_dates
  },
  methods: {
    ...mapActions('workExtraType', ['onWorkExtraTypeAll']),
    ...mapActions('employeeWorkDay', [
      'onEmployeeWorkDay_dayReport_post',
      'onEmployeeWorkDay_periodReport_post',
      'onEmployeeWorkDay_extra_post',
    ]),
    requiredBlockSelection(value) {
      return (
        value !== '__select_block__' ||
        this.localStorage.translations.pages.common.rules.obyazatelno
      )
    },
    onOpenCreate() {
      this.stage = 0
      if (typeof this.createDay === 'string') {
        this.start_date = this.$parseDate(this.createDay)
      }
      if (this.updateDay) {
        const [start_date, start_time] = this.updateDay.start.split(' ')
        this.start_date = start_date
        this.start_time = start_time
        if (this.updateDay.end) {
          const [end_date, end_time] = this.updateDay.end.split(' ')
          this.end_date = end_date
          this.end_time = end_time
        }
      }

      this.$refs.modal.openModal()
    },
    onNextStage({ project_id, is_extra, employee_period_id, work_extra_type_id }) {
      if (this.stage === 1) {
        this.projectSelect = { id: project_id, is_extra: is_extra }
        this.stage = 2
      } else if (this.stage === 2) {
        this.workSelect = {
          employee_period_id: employee_period_id,
          work_extra_type_id: work_extra_type_id,
        }
        this.selected_block = '__select_block__'
        this.stage = 3
      }
    },
    onPrevStage() {
      if (this.stage === 2) {
        this.projectSelect = null
        this.stage = 1
      } else if (this.stage === 3) {
        this.workSelect = null
        this.size = null
        this.hours = null
        this.piecework_time_hour = null
        this.pieceworkTime = null
        this.selected_block = '__select_block__'
        this.report = null
        this.stage = 2
      }
    },
    onProjectsList() {
      console.log('onProjectsList')
      let result = []
      if (this.employeeReports.periods !== null && this.dates && this.dates.start) {
        for (let work of this.employeeReports.periods.filter((i) =>
          this.dates.end
            ? this.dates.start.split(' ')[0] >= i.start_date &&
              this.dates.start.split(' ')[0] <= i.end_date &&
              this.dates.end.split(' ')[0] >= i.start_date &&
              this.dates.end.split(' ')[0] <= i.end_date
            : this.dates.start.split(' ')[0] >= i.start_date &&
              this.dates.start.split(' ')[0] <= i.end_date,
        )) {
          const checkProject = (obj) =>
            obj.project_id === work.project_id && obj.is_extra === work.is_extra
          if (result.findIndex(checkProject) === -1) {
            result.push({
              project_id: work.project_id,
              project: work.project,
              is_extra: work.is_extra,
            })
          }
        }
      }
      return result
    },
    onCreateOrUpdateDay() {
      console.log('onCreateOrUpdateDay')
      if (this.$refs.modal.$refs.form.validate()) {
        const dayStart = this.start_date
        let data = {
          employee_id: this.$route.params.employeeId,
          start:
            dayStart +
            ' ' +
            (this.start_time.length === 5 ? this.start_time + ':00' : this.start_time),
        }
        if (this.end_time) {
          data.end =
            this.end_date +
            ' ' +
            (this.end_time.length === 5 ? this.end_time + ':00' : this.end_time)
        }
        if (this.updateDay) {
          data.employee_work_day_id = this.employee_work_day_id
        }
        this.onEmployeeWorkDay_dayReport_post(data)
          .then((resp) => {
            if (this.createDay) {
              this.work_day_id = resp.data.id
              this.stage = 1
              this.dates = {
                start: resp.data.start,
                end: resp.data.end,
              }
            }
            this.functionUpdate({ day: dayStart, calendar: true })
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'izmeneniya-uspeshno-sohraneny'
                  ],
                IsError: false,
              },
              { root: true },
            )
            if (this.updateDay) {
              this.$refs.modal.closeModal()
            }
          })
          .catch((err) => {
            console.log(err)
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['oshibka'] +
                  ' ' +
                  err.response.data.message,
                IsError: true,
              },
              { root: true },
            )
          })
      }
    },
    onCreateReport() {
      console.log('onCreateReport')
      if (this.$refs.modal.$refs.form.validate()) {
        const dayStart = this.start_date
        let data = {
          employee_id: this.$route.params.employeeId,
          employee_work_day_id: this.employee_work_day_id || this.work_day_id,
          size: this.size,
          hours: this.hours,
          piecework_time_hour: this.piecework_time_hour,
          report: this.report,
        }
        if (this.workSelect.employee_period_id) {
          data.employee_period_id = this.workSelect.employee_period_id
          data.selected_block = this.selected_block || null
          const selectedPeriod = this.employeeReports.periods.find(
            (i) => i.employee_period_id === this.workSelect.employee_period_id,
          )
          if (selectedPeriod && selectedPeriod.is_hourly === 0) {
            data.hours = null
          } else {
            data.piecework_time_hour = null
          }
        } else {
          data.project_id = this.projectSelect.id
          data.work_extra_type_id = this.workSelect.work_extra_type_id
          data.selected_block = this.selected_block || null
          data.data = null
          data.piecework_time_hour = null
        }
        ;(data.employee_period_id
          ? this.onEmployeeWorkDay_periodReport_post(data)
          : this.onEmployeeWorkDay_extra_post(data)
        )
          .then(() => {
            this.functionUpdate({ day: dayStart, calendar: true })
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications[
                    'izmeneniya-uspeshno-sohraneny'
                  ],
                IsError: false,
              },
              { root: true },
            )
            this.$refs.modal.closeModal()
          })
          .catch((err) => {
            console.log(err)
            this.$store.dispatch(
              'popup/onMessage',
              {
                message:
                  this.localStorage.translations.pages.common.notifications['oshibka'] +
                  ' ' +
                  err.response.data.message,
                IsError: true,
              },
              { root: true },
            )
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  & > div {
    width: 100%;
  }
  &_buttons {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    gap: 20px;
    &--center {
      justify-content: center;
    }
  }
}
.day {
  max-width: 440px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  gap: 20px;
  justify-content: center;
  @media screen and (max-width: 550px) {
    grid-template-columns: 1fr;
  }
}
.projects {
  &_grid {
    display: grid;
    gap: 18px;
  }
  &_item {
    background: #ffffff;
    border: 1px solid #ffffff;
    border-radius: 4px;
    max-width: 584px;
    width: 100%;
    padding: 25px;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      border: 1px solid #277faf;
    }
  }
}
.works {
  &_item {
    padding: 23px;
    border: 1px solid #d1d1d1;
    &--head {
      background: #277faf;
      color: #ffffff;
      border: none;
    }
    &--subhead {
      background: #fafafa;
    }
    &--work {
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        scale: 1.01;
      }
    }
  }
}
.last {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  &_col {
    display: grid;
    gap: 20px;
    height: max-content;
  }
  @media screen and (max-width: 650px) {
    grid-template-columns: 1fr;
  }
}
</style>
